import CustomModal from "@components/common/CustomModal";
import { NavigationButton } from "@components/common/NavigationLink";
import AddAdminForm from "@forms/addAdmin";
import { AdminPanelSettings, Engineering, PersonAddAlt, SupportAgent } from "@mui/icons-material";
import { Button } from "@mui/material";
import { RoutePaths } from "@utils/constants/routes";
import { useTranslation } from "react-i18next";

import LinksSubHeader from "..";

function AdminSubHeader() {
  const { t } = useTranslation();

  return (
    <LinksSubHeader>
      <CustomModal
        cancelText={t("common.actions.cancel")}
        confirmText={t("common.actions.submit")}
        color="primary"
        button={
          <Button
            variant="contained"
            color="primary"
            startIcon={<PersonAddAlt />}
            size="small"
            sx={{ fontSize: "0.75rem" }}
          >
            {t("layouts.header.new-manager")}
          </Button>
        }
        formId="addAdmin"
      >
        <AddAdminForm />
      </CustomModal>
      <NavigationButton to={RoutePaths.adminManageAdmins} includes={RoutePaths.admins}>
        <AdminPanelSettings />
        <span style={{ fontSize: "0.75rem" }}>
          {t("layouts.sub-headers.managers.super-admins")}
        </span>
      </NavigationButton>
      <NavigationButton to={RoutePaths.adminManageMaintainer} includes={RoutePaths.maintainers}>
        <Engineering />
        <span style={{ fontSize: "0.75rem" }}>{t("layouts.sub-headers.managers.maintainers")}</span>
      </NavigationButton>
      <NavigationButton to={RoutePaths.adminManageSupport} includes={RoutePaths.support}>
        <SupportAgent />
        <span style={{ fontSize: "0.75rem" }}>{t("layouts.sub-headers.managers.assistants")}</span>
      </NavigationButton>
    </LinksSubHeader>
  );
}

export default AdminSubHeader;
